import { Button, TextField, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import GoogleButton from '../googlebutton/GoogleButton';
import { useGoogleSignIn } from '../hooks/useGoogleSignIn';
import { useEmailSignIn } from '../hooks/useEmailSignIn';
import {
  StyledContainer,
  StyledFormContainer,
  StyledGoogleButtonContainer,
  StyledDividerContainer,
  StyledDividerText,
  StyledDivider,
  StyledForm,
  StyledRegisterLink
} from './Login.styled'

export default function LoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const { isLoading: isGoogleLoading, error: googleError, handleGoogleSignIn } = useGoogleSignIn();
  const { isLoading: isEmailLoading, error: emailError, handleEmailSignIn } = useEmailSignIn();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleEmailSignIn(formData.email, formData.password);
  };

  const isLoading = isGoogleLoading || isEmailLoading;
  const error = googleError || emailError;

  return (
    <StyledContainer maxWidth="sm">
      <StyledFormContainer>
        <Typography variant="h4" component="h1" gutterBottom>
          Login
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Login in to your account or use Google
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <StyledGoogleButtonContainer>
          <GoogleButton isLoading={isLoading} handleGoogleSignIn={handleGoogleSignIn} />
        </StyledGoogleButtonContainer>

        <StyledDividerContainer>
          <StyledDividerText variant="caption">
            OR CONTINUE WITH
          </StyledDividerText>
          <StyledDivider />
        </StyledDividerContainer>

        <StyledForm onSubmit={handleSubmit}>
          <TextField
            id="email"
            name="email"
            label="Email"
            type="email"
            placeholder="email@example.com"
            required
            fullWidth
            value={formData.email}
            onChange={handleInputChange}
            disabled={isLoading}
          />
          <TextField
            id="password"
            name="password"
            label="Password"
            type="password"
            placeholder="********"
            required
            fullWidth
            value={formData.password}
            onChange={handleInputChange}
            disabled={isLoading}
          />
          <Button
            variant="contained"
            type="submit"
            fullWidth
            sx={{ mt: 1 }}
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Login'}
          </Button>
          <StyledRegisterLink
            variant="body2"
            onClick={() => navigate('/register')}
          >
            Noch kein Konto? Hier registrieren!
          </StyledRegisterLink>
        </StyledForm>
      </StyledFormContainer>
    </StyledContainer>
  );
}
